import React, { useState, useEffect, useRef } from 'react';
import Navbar from '../../navbar';
import TopNavbar from '../../topnavbar';
import Footer from '../../footer';
import '../../../App.css';


const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];

const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: 5 }, (_, i) => currentYear - i);
const ROWS_PER_PAGE = 10;

const styles = {
    th: {
        backgroundColor: '#4e73df',
        color: '#fff',
        fontWeight: '700',
        fontSize: '12px',
        padding: '10px 12px',
        textAlign: 'center',
        borderBottom: 'none',
        whiteSpace: 'nowrap',
    },
    td: {
        padding: '9px 12px',
        textAlign: 'center',
        fontSize: '12px',
        color: '#5a5c69',
        verticalAlign: 'middle',
        borderTop: '1px solid #e3e6f0',
        whiteSpace: 'nowrap',
    },
    input: {
        border: '1px solid #d1d3e2',
        borderRadius: '5px',
        padding: '7px 12px',
        fontSize: '13px',
        color: '#5a5c69',
        outline: 'none',
        width: '100%',
    },
    label: {
        fontSize: '12px',
        fontWeight: '700',
        color: '#5a5c69',
        marginBottom: '4px',
        display: 'block',
    },
    cardHeader: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #e3e6f0',
    },
    sectionDivider: {
        borderTop: '1px solid #e3e6f0',
        marginTop: '20px',
        paddingTop: '16px',
    },
};

const btn = (bg = '#4e73df', disabled = false) => ({
    backgroundColor: disabled ? '#b7c3ef' : bg,
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    padding: '8px 20px',
    fontSize: '13px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontWeight: '600',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
});

function FormLabel({ children, required }) {
    return (
        <label style={styles.label}>
            {children}
            {required && <span style={{ color: '#e74a3b' }}> *</span>}
        </label>
    );
}

function AlertBanner({ type, message }) {
    const colors = {
        success: { bg: '#d4edda', border: '#c3e6cb', text: '#155724', icon: 'fa-check-circle' },
        error:   { bg: '#f8d7da', border: '#f5c6cb', text: '#721c24', icon: 'fa-exclamation-circle' },
        warning: { bg: '#fff3cd', border: '#ffc107', text: '#856404', icon: 'fa-exclamation-triangle' },
    };
    const c = colors[type] || colors.error;
    return (
        <div style={{
            backgroundColor: c.bg, border: `1px solid ${c.border}`, borderRadius: '5px',
            padding: '10px 16px', marginBottom: '16px', color: c.text,
            fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px',
        }}>
            <i className={`fas ${c.icon}`}></i>
            {message}
        </div>
    );
}

function Toast({ toast, onClose }) {
    if (!toast) return null;
    return (
        <div style={{
            position: 'fixed', top: '20px', right: '20px', zIndex: 99999,
            backgroundColor: toast.type === 'error' ? '#e74a3b' : '#1cc88a',
            color: '#fff', padding: '14px 20px', borderRadius: '8px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.2)', fontSize: '13px',
            fontWeight: '600', display: 'flex', alignItems: 'center',
            gap: '10px', minWidth: '280px', animation: 'slideIn 0.3s ease',
        }}>
            <i className={`fas ${toast.type === 'error' ? 'fa-exclamation-circle' : 'fa-check-circle'}`}
                style={{ fontSize: '16px' }}></i>
            <span style={{ flex: 1 }}>{toast.message}</span>
            <button onClick={onClose}
                style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: '16px', lineHeight: 1, padding: 0 }}>
                <i className="fas fa-times"></i>
            </button>
        </div>
    );
}

function ConfirmDeleteModal({ onCancel, onConfirm }) {
    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 99998,
            backgroundColor: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
            <div style={{
                backgroundColor: '#fff', borderRadius: '10px', padding: '32px',
                width: '380px', boxShadow: '0 8px 30px rgba(0,0,0,0.2)', textAlign: 'center',
            }}>
                <i className="fas fa-exclamation-triangle" style={{ fontSize: '44px', color: '#e74a3b', marginBottom: '16px' }}></i>
                <h6 style={{ fontWeight: '700', color: '#2d3748', marginBottom: '8px', fontSize: '16px' }}>
                    Delete Record
                </h6>
                <p style={{ fontSize: '13px', color: '#5a5c69', marginBottom: '24px' }}>
                    Are you sure you want to delete this record? This action cannot be undone.
                </p>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                    <button style={btn('#858796')} onClick={onCancel}>
                        <i className="fas fa-times"></i> Cancel
                    </button>
                    <button style={btn('#e74a3b')} onClick={onConfirm}>
                        <i className="fas fa-trash"></i> Yes, Delete
                    </button>
                </div>
            </div>
        </div>
    );
}

// Main Component ─────────────────────────────────────────────────────────────
function SSSBilling() {
    const [uploads,       setUploads]       = useState([]);
    const [loading,       setLoading]       = useState(true);

    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear,  setSelectedYear]  = useState(String(currentYear));
    const [file,          setFile]          = useState(null);
    const [dragging,      setDragging]      = useState(false);
    const [remarks,       setRemarks]       = useState('');
    const [batch,         setBatch]         = useState('');

    const [successMsg,    setSuccessMsg]    = useState('');
    const [errorMsg,      setErrorMsg]      = useState('');
    const [filterYear,    setFilterYear]    = useState('All');
    const [filterMonth,   setFilterMonth]   = useState('All');

    const [previewing,    setPreviewing]    = useState(false);
    const [confirming,    setConfirming]    = useState(false);
    const [previewData,   setPreviewData]   = useState(null);
    const [isEditing,     setIsEditing]     = useState(false);
    const [editingCell,   setEditingCell]   = useState(null);
    const [previewPage,   setPreviewPage]   = useState(1);

    const [toast,         setToast]         = useState(null);
    const [confirmModal,  setConfirmModal]  = useState(null);

    const facility   = sessionStorage.getItem('facility') || '';
    const previewRef = useRef(null);
    const [warnings, setWarnings] = useState([]);
    const warningsRef = useRef(null);
    const topRef = useRef(null);

    useEffect(() => { fetchUploads(); }, []);

    useEffect(() => {
        if (previewData && previewRef.current) {
            previewRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [previewData]);

    const showToast = (message, type = 'success') => {
        setToast({ message, type });
        setTimeout(() => setToast(null), 3000);
    };

    const isAlreadyUploaded = (month, year) =>
        uploads.some(u => u.BillingMonth === month && String(u.BillingYear) === String(year));

    const isDuplicate = selectedMonth && selectedYear && isAlreadyUploaded(selectedMonth, selectedYear);

    const filtered = uploads.filter(u => {
        const matchesYear  = filterYear  === 'All' || String(u.BillingYear) === filterYear;
        const matchesMonth = filterMonth === 'All' || u.BillingMonth === filterMonth;
        return matchesYear && matchesMonth;
    });

    const clearForm = () => {
        setFile(null);
        setSelectedMonth('');
        setRemarks('');
        setBatch('');
        setSuccessMsg('');
        setErrorMsg('');
        setPreviewData(null);
        setIsEditing(false);
        setEditingCell(null);
        setWarnings([]);
        const fileInput = document.getElementById('sss-file-input');
        if (fileInput) fileInput.value = '';
    };

    const fetchUploads = async () => {
        setLoading(true);
        try {
            const res = await fetch(`/api/billing/sss?facility=${encodeURIComponent(facility)}`);
            if (res.ok) setUploads(await res.json());
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handlePreview = async () => {
        if (!selectedMonth) return setErrorMsg('Please select a billing month.');
        if (!selectedYear)  return setErrorMsg('Please select a billing year.');
        if (!file)          return setErrorMsg('Please attach a file.');
        if (isDuplicate) {
            return setErrorMsg(`A billing file for ${selectedMonth} ${selectedYear} has already been uploaded.`);
        }

        setPreviewing(true);
        setErrorMsg('');
        setSuccessMsg('');

        try {
            const formData = new FormData();
            formData.append('file',         file);
            formData.append('billingMonth', selectedMonth);
            formData.append('billingYear',  selectedYear);
            formData.append('fileFrom',     'SSS');

            const res = await fetch('/api/billing/sss/preview', { method: 'POST', body: formData });

            if (res.ok) {
                const data = await res.json();
                setPreviewData(data);
                setPreviewPage(1);
                setWarnings(data.warnings ?? []);
                setTimeout(() => {
                    if (data.warnings?.length > 0) {
                        warningsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                    previewRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 100);
            } else {
                const err = await res.json();
                setErrorMsg(err.message || 'Preview failed.');
            }
        } catch (err) {
            console.error('Preview error:', err);
            setErrorMsg(`An unexpected error occurred: ${err.message}`);
        } finally {
            setPreviewing(false);
        }
    };

    const handleConfirm = async () => {
        setConfirming(true);
        const ext      = file.name.toLowerCase().split('.').pop();
        const fileType = ext === 'pdf' ? 'PDF' : 'Excel';
        const employeeId = sessionStorage.getItem('employeeId');

        try {
            const res = await fetch('/api/billing/sss/confirm', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    rows:         previewData.rows,
                    billingMonth: selectedMonth,
                    billingYear:  selectedYear,
                    remarks,
                    fileFrom:     'SSS',
                    fileType,
                    fileName:     previewData.originalFileName,
                    filePath:     previewData.savedFilePath,
                    employeeId,
                    batch,
                }),
            });

            if (res.ok) {
                showToast(`SSS billing for ${selectedMonth} ${selectedYear} saved`);
                setPreviewData(null);
                clearForm();
                fetchUploads();
            } else {
                const err = await res.json();
                showToast(err.message || 'Confirm failed.', 'error');
            }
        } catch {
            showToast('An unexpected error occurred.', 'error');
        } finally {
            setConfirming(false);
        }
    };

    const handleDelete = (billingId) => setConfirmModal({ billingId });

    const confirmDelete = async () => {
        const { billingId } = confirmModal;
        setConfirmModal(null);
        try {
            const res = await fetch(`/api/billing/sss/${billingId}`, { method: 'DELETE' });
            if (res.ok) {
                showToast('Record deleted successfully.');
                fetchUploads();
            } else {
                const err = await res.json();
                showToast(err.message || 'Delete failed.', 'error');
            }
        } catch (err) {
            console.error('Delete error:', err);
            showToast('An unexpected error occurred.', 'error');
        }
    };

    const handleDownload = async (u) => {
        try {
            const response = await fetch(`/api/billing/sss/download/${u.BillingId}`);
            if (!response.ok) {
                const err = await response.json();
                showToast(err.message || 'Download failed.', 'error');
                return;
            }
            const blob = await response.blob();
            const url  = window.URL.createObjectURL(blob);
            const a    = document.createElement('a');
            a.href     = url;
            a.download = u.FileName || 'billing.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Download error:', err);
            showToast('Download failed.', 'error');
        }
    };

    const handleFileChange = (e) => {
        const f = e.target.files[0];
        if (f) { setFile(f); setErrorMsg(''); }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        const f = e.dataTransfer.files[0];
        if (f) { setFile(f); setErrorMsg(''); }
    };

    const totalPages  = previewData ? Math.ceil(previewData.rows.length / ROWS_PER_PAGE) : 0;
    const startIdx    = (previewPage - 1) * ROWS_PER_PAGE;
    const currentRows = previewData ? previewData.rows.slice(startIdx, startIdx + ROWS_PER_PAGE) : [];

    return (
        <div id="wrapper">
            <Navbar />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopNavbar />
                    <div className="container-fluid">

                        {/* Global Animations */}
                        <style>{`
                            @keyframes slideIn {
                                from { opacity: 0; transform: translateX(40px); }
                                to   { opacity: 1; transform: translateX(0); }
                            }
                        `}</style>

                        {/* ── Overlays ── */}
                        <Toast toast={toast} onClose={() => setToast(null)} />
                        {confirmModal && (
                            <ConfirmDeleteModal
                                onCancel={() => setConfirmModal(null)}
                                onConfirm={confirmDelete}
                            />
                        )}

                        {/* ── Page Title ── */}
                        <div ref={topRef} className="row justify-content-center mb-3">
                            <h4 className="m-0 font-weight-bold text-primary header-name">
                                SSS Billing Upload
                            </h4>
                        </div>

                        {/* SECTION: Upload New Billing Statement */}
                        <div className="card shadow mb-4">
                            <div className="card-header py-3" style={styles.cardHeader}>
                                <h6 className="m-0 font-weight-bold text-primary">
                                    <i className="fas fa-upload mr-2"></i>Upload New Billing Statement
                                </h6>
                            </div>
                            <div className="card-body">

                                {/* Alert Messages */}
                                {successMsg && <AlertBanner type="success" message={successMsg} />}
                                {errorMsg   && <AlertBanner type="error"   message={errorMsg}   />}

                                {/* ── Row 1: Billing Details ── */}
                                <div style={{ marginBottom: '20px' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                                        <div>
                                            <FormLabel required>Billing Month</FormLabel>
                                            <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} style={styles.input}>
                                                <option value="">-- Select Month --</option>
                                                {MONTHS.map(m => <option key={m} value={m}>{m}</option>)}
                                            </select>
                                        </div>
                                        <div>
                                            <FormLabel required>Billing Year</FormLabel>
                                            <select value={selectedYear} onChange={e => setSelectedYear(e.target.value)} style={styles.input}>
                                                {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                                            </select>
                                        </div>
                                        <div>
                                            <FormLabel required>Batch</FormLabel>
                                            <select value={batch} onChange={e => setBatch(e.target.value)} style={styles.input}>
                                                <option value="">-- Select Batch --</option>
                                                <option value="1">Batch 1</option>
                                                <option value="2">Batch 2</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* ── Row 2: File Upload + Remarks ── */}
                                <div style={{ marginBottom: '20px' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>

                                        {/* Drop Zone */}
                                        <div>
                                            <FormLabel>Billing File</FormLabel>
                                            <div
                                                style={{
                                                    border: `2px dashed ${dragging ? '#4e73df' : '#d1d3e2'}`,
                                                    borderRadius: '8px',
                                                    padding: '36px 24px',
                                                    textAlign: 'center',
                                                    backgroundColor: dragging ? '#eef0fb' : '#f8f9fc',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                }}
                                                onClick={() => document.getElementById('sss-file-input').click()}
                                                onDragOver={e => { e.preventDefault(); setDragging(true); }}
                                                onDragLeave={() => setDragging(false)}
                                                onDrop={handleDrop}
                                            >
                                                <i className="fas fa-cloud-upload-alt fa-3x"
                                                    style={{ color: '#4e73df', opacity: 0.4, marginBottom: '10px' }}></i>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#5a5c69' }}>
                                                    Drag &amp; drop billing file here
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#858796', marginTop: '4px' }}>
                                                    or <span style={{ color: '#4e73df', textDecoration: 'underline' }}>click to browse</span>
                                                </div>
                                                <div style={{ fontSize: '11px', color: '#b7bac9', marginTop: '6px' }}>
                                                    Accepted: .xlsx, .xls, .csv
                                                </div>
                                                <input
                                                    id="sss-file-input"
                                                    type="file"
                                                    accept=".xlsx,.xls,.csv"
                                                    style={{ display: 'none' }}
                                                    onChange={handleFileChange}
                                                />
                                            </div>

                                            {/* Selected File Chip */}
                                            {file && (
                                                <div style={{
                                                    display: 'flex', alignItems: 'center', gap: '10px',
                                                    marginTop: '12px', padding: '10px 14px',
                                                    backgroundColor: '#eef0fb', borderRadius: '6px',
                                                    border: '1px solid #d1d3e2',
                                                }}>
                                                    <i className="fas fa-file-excel" style={{ color: '#1cc88a', fontSize: '18px' }}></i>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#5a5c69' }}>{file.name}</div>
                                                        <div style={{ fontSize: '11px', color: '#858796' }}>{(file.size / 1024).toFixed(1)} KB</div>
                                                    </div>
                                                    <button
                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#e74a3b', fontSize: '16px' }}
                                                        onClick={() => setFile(null)}
                                                    >
                                                        <i className="fas fa-times"></i>
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        {/* Remarks */}
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <FormLabel>Remarks</FormLabel>
                                            <textarea
                                                placeholder="Optional notes..."
                                                value={remarks}
                                                onChange={e => setRemarks(e.target.value)}
                                                style={{ ...styles.input, flex: 1, minHeight: '120px', resize: 'vertical' }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Duplicate Warning */}
                                {isDuplicate && (
                                    <AlertBanner
                                        type="warning"
                                        message={<>A billing record for <strong>&nbsp;{selectedMonth} {selectedYear}&nbsp;</strong> already exists. You cannot upload a duplicate.</>}
                                    />
                                )}

                                {/* ── Form Actions ── */}
                                <div style={{ ...styles.sectionDivider, display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                    <button style={btn('#858796')} onClick={clearForm}>
                                        <i className="fas fa-undo"></i> Clear
                                    </button>
                                    <button
                                        style={btn('#4e73df', !file || !selectedMonth || previewing || isDuplicate)}
                                        onClick={handlePreview}
                                        disabled={!file || !selectedMonth || previewing || isDuplicate}
                                    >
                                        {previewing
                                            ? <><i className="fas fa-spinner fa-spin"></i> Extracting...</>
                                            : <><i className="fas fa-search"></i> Preview</>}
                                    </button>
                                </div>

                            </div>
                        </div>

                        {/* ── Warnings ── */}
                        {warnings.length > 0 && (
                            <div ref={warningsRef} style={{
                                backgroundColor: '#fff3cd',
                                border: '1px solid #ffc107',
                                borderRadius: '8px',
                                padding: '14px 18px',
                                marginBottom: '16px',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    fontWeight: '700',
                                    fontSize: '13px',
                                    color: '#856404',
                                    marginBottom: warnings.length > 1 ? '10px' : 0,
                                }}>
                                    <i className="fas fa-exclamation-triangle"></i>
                                    {warnings.length === 1 ? '1 Warning' : `${warnings.length} Warnings`}
                                </div>
                                {warnings.length === 1 ? (
                                    <div style={{ fontSize: '12px', color: '#856404' }}>{warnings[0]}</div>
                                ) : (
                                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                        {warnings.map((w, i) => (
                                            <li key={i} style={{ fontSize: '12px', color: '#856404', marginBottom: '4px' }}>
                                                {w}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        )}

                        {/* SECTION: Preview  */}
                        {previewData && previewData.rows?.length > 0 && (
                            <div className="card shadow mb-4" ref={previewRef}>
                                <div className="card-header py-3" style={{
                                    ...styles.cardHeader,
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                }}>
                                    <h6 className="m-0 font-weight-bold text-primary">
                                        <i className="fas fa-eye mr-2"></i>
                                        Preview — {previewData.rows.length} rows extracted
                                    </h6>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <span style={{ fontSize: '12px', color: '#858796' }}>
                                            Page {previewPage} of {totalPages}
                                        </span>
                                        <button
                                            style={btn(isEditing ? '#e74a3b' : '#f6c23e')}
                                            onClick={() => { setIsEditing(prev => !prev); setEditingCell(null); }}
                                        >
                                            <i className={`fas ${isEditing ? 'fa-times' : 'fa-edit'}`}></i>
                                            {isEditing ? ' Stop Editing' : ' Edit Table'}
                                        </button>
                                    </div>
                                </div>

                                <div className="card-body" style={{ padding: 0 }}>
                                    <div style={{ overflowX: 'auto' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr>
                                                    {Object.keys(previewData.rows[0]).map(col => (
                                                        <th key={col} style={styles.th}>{col}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentRows.map((row, idx) => (
                                                    <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fc' }}>
                                                        {Object.entries(row).map(([col, val], i) => {
                                                            const globalIdx      = startIdx + idx;
                                                            const isThisEditing  = isEditing && editingCell?.rowIdx === globalIdx && editingCell?.col === col;

                                                            return (
                                                                <td
                                                                    key={i}
                                                                    style={{ ...styles.td, cursor: isEditing ? 'text' : 'default' }}
                                                                    onClick={() => { if (isEditing) setEditingCell({ rowIdx: globalIdx, col }); }}
                                                                >
                                                                    {isEditing ? (
                                                                        <input
                                                                            readOnly={!isThisEditing}
                                                                            autoFocus={isThisEditing}
                                                                            value={val ?? ''}
                                                                            onChange={e => {
                                                                                const updatedRows = [...previewData.rows];
                                                                                updatedRows[globalIdx] = { ...updatedRows[globalIdx], [col]: e.target.value };
                                                                                setPreviewData(prev => ({ ...prev, rows: updatedRows }));
                                                                            }}
                                                                            onFocus={() => setEditingCell({ rowIdx: globalIdx, col })}
                                                                            onBlur={() => setEditingCell(null)}
                                                                            onKeyDown={e => { if (e.key === 'Enter' || e.key === 'Escape') setEditingCell(null); }}
                                                                            style={{
                                                                                border: isThisEditing ? '1px solid #4e73df' : '1px solid #e3e6f0',
                                                                                borderRadius: '4px',
                                                                                padding: '5px 8px',
                                                                                fontSize: '12px',
                                                                                color: '#5a5c69',
                                                                                width: '100%',
                                                                                minWidth: 'max-content',
                                                                                textAlign: 'center',
                                                                                backgroundColor: isThisEditing ? '#fff' : 'transparent',
                                                                                outline: 'none',
                                                                                cursor: 'text',
                                                                                boxSizing: 'border-box',
                                                                                boxShadow: isThisEditing ? '0 0 0 2px rgba(78,115,223,0.2)' : 'none',
                                                                                transition: 'border 0.15s, box-shadow 0.15s',
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        val ?? '—'
                                                                    )}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination + Actions */}
                                    <div style={{
                                        display: 'flex', justifyContent: 'space-between',
                                        alignItems: 'center', gap: '10px',
                                        padding: '16px', borderTop: '1px solid #e3e6f0',
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <button
                                                style={btn('#6c757d', previewPage === 1)}
                                                onClick={() => setPreviewPage(p => p - 1)}
                                                disabled={previewPage === 1}
                                            >
                                                <i className="fas fa-chevron-left"></i> Previous
                                            </button>
                                            <span style={{ fontSize: '12px', color: '#5a5c69' }}>
                                                Showing {startIdx + 1}–{Math.min(startIdx + ROWS_PER_PAGE, previewData.rows.length)} of {previewData.rows.length} rows
                                            </span>
                                            <button
                                                style={btn('#6c757d', previewPage === totalPages)}
                                                onClick={() => setPreviewPage(p => p + 1)}
                                                disabled={previewPage === totalPages}
                                            >
                                                Next <i className="fas fa-chevron-right"></i>
                                            </button>
                                        </div>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <button
                                                style={btn('#858796')}
                                                onClick={() => { 
                                                    setPreviewData(null); 
                                                    setPreviewPage(1); 
                                                    setIsEditing(false); 
                                                    setEditingCell(null);
                                                    setWarnings([]); 
                                                    topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                 }}
                                            >
                                                <i className="fas fa-times"></i> Cancel
                                            </button>
                                            <button style={btn('#1cc88a', confirming)} onClick={handleConfirm} disabled={confirming}>
                                                {confirming
                                                    ? <><i className="fas fa-spinner fa-spin"></i> Saving...</>
                                                    : <><i className="fas fa-check"></i> Confirm &amp; Save</>}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* SECTION: Upload History */}
                        <div className="card shadow mb-4">
                            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between"
                                style={styles.cardHeader}>
                                <h6 className="m-0 font-weight-bold text-primary">
                                    <i className="fas fa-history mr-2"></i>Upload History
                                </h6>
                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                    <select value={filterMonth} onChange={e => setFilterMonth(e.target.value)}
                                        style={{ ...styles.input, width: '150px' }}>
                                        <option value="All">All Months</option>
                                        {MONTHS.map(m => <option key={m} value={m}>{m}</option>)}
                                    </select>
                                    <select value={filterYear} onChange={e => setFilterYear(e.target.value)}
                                        style={{ ...styles.input, width: '120px' }}>
                                        <option value="All">All Years</option>
                                        {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                                    </select>
                                    <button style={btn()} onClick={fetchUploads}>
                                        <i className="fas fa-sync-alt"></i> Refresh
                                    </button>
                                </div>
                            </div>

                            <div className="card-body" style={{ padding: 0 }}>
                                {loading ? (
                                    <div style={{ textAlign: 'center', padding: '40px', color: '#858796' }}>
                                        <i className="fas fa-spinner fa-spin fa-2x"></i>
                                        <div style={{ marginTop: '12px' }}>Loading records...</div>
                                    </div>
                                ) : (
                                    <div style={{ overflowX: 'auto' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff' }}>
                                            <thead>
                                                <tr>
                                                    {['#', 'Billing Month', 'Billing Year', 'File Name', 'Uploaded By', 'Upload Date', 'Remarks', 'Actions', ''].map(h => (
                                                        <th key={h} style={styles.th}>{h}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filtered.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={9} style={{ ...styles.td, padding: '40px', color: '#858796' }}>
                                                            <i className="fas fa-inbox fa-2x" style={{ display: 'block', marginBottom: '8px' }}></i>
                                                            No upload records found.
                                                        </td>
                                                    </tr>
                                                ) : filtered.map((u, idx) => (
                                                    <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fc' }}>
                                                        <td style={styles.td}>{idx + 1}</td>
                                                        <td style={styles.td}>{u.BillingMonth ?? '—'}</td>
                                                        <td style={styles.td}>{u.BillingYear ?? '—'}</td>
                                                        <td style={{ ...styles.td, maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            <i className="fas fa-file-alt mr-1" style={{ color: '#1cc88a' }}></i>
                                                            {u.FileName ?? '—'}
                                                        </td>
                                                        <td style={styles.td}>{u.UploadedByName ?? u.UploadedBy ?? '—'}</td>
                                                        <td style={styles.td}>{u.DateTime ? u.DateTime.slice(0, 10) : '—'}</td>
                                                        <td style={styles.td}>{u.Remarks || '—'}</td>
                                                        <td style={styles.td}>
                                                            <button style={btn('#36b9cc')} onClick={() => handleDownload(u)}>
                                                                <i className="fas fa-download"></i> Download
                                                            </button>
                                                        </td>
                                                        <td style={styles.td}>
                                                            <button
                                                                title="Delete"
                                                                onClick={() => handleDelete(u.BillingId)}
                                                                style={{
                                                                    background: 'none', border: 'none',
                                                                    cursor: 'pointer', color: '#adb5bd',
                                                                    fontSize: '16px', padding: '4px 8px',
                                                                    lineHeight: 1, borderRadius: '4px',
                                                                    transition: 'color 0.15s',
                                                                }}
                                                                onMouseEnter={e => e.currentTarget.style.color = '#e74a3b'}
                                                                onMouseLeave={e => e.currentTarget.style.color = '#adb5bd'}
                                                            >
                                                                <i className="fas fa-times"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default SSSBilling;